// Animates elements marked with [data-countup] counting up from zero
// when they enter the viewport. The number format (grouping commas and
// decimals) is inferred from the element's original text, so values like
// "3,000", "20" or "4.9" keep their formatting while animating.
const DURATION = 1600;

function formatValue(value, template) {
  const useGrouping = template.includes(',');
  const decimals = (template.split('.')[1] || '').length;

  return value.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping,
  });
}

function animate(element) {
  const original = element.textContent.trim();
  const target = parseFloat(original.replace(/,/g, ''));

  if (isNaN(target)) return;

  const start = performance.now();

  const step = (now) => {
    const progress = Math.min((now - start) / DURATION, 1);
    const eased = 1 - Math.pow(1 - progress, 3);

    if (progress < 1) {
      element.textContent = formatValue(target * eased, original);
      requestAnimationFrame(step);
    } else {
      element.textContent = original;
    }
  };

  requestAnimationFrame(step);
}

const elements = document.querySelectorAll('[data-countup]');

if (elements.length) {
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animate(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });

  elements.forEach((element) => observer.observe(element));
}
